import { render, staticRenderFns } from "./ChinaMarket.vue?vue&type=template&id=f963562e&scoped=true"
import script from "./ChinaMarket.vue?vue&type=script&lang=js"
export * from "./ChinaMarket.vue?vue&type=script&lang=js"
import style0 from "./ChinaMarket.vue?vue&type=style&index=0&id=f963562e&prod&lang=scss"
import style1 from "./ChinaMarket.vue?vue&type=style&index=1&id=f963562e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f963562e",
  null
  
)

export default component.exports